
class CardPreview {
    [x: string]: any;
    cardClass() {
        if (!this.type) return;
        if (this.type === 'American Express') return 'jp-card-amex';
        else return 'jp-card-' + this.type.toLowerCase();
    }
}
export default {
    controller: CardPreview,
    template : require('./card.preview.html'),
    bindings: {card: "<", type: "<", flipped: "<"}
};
